module.exports = __webpack_public_path__ + "d901112a7c0f359dece211fca65ecbde.glb";